import type { ComparisonFilters } from "../../../shared/contracts/product-pages.js";

export function comparisonQuery(filters: ComparisonFilters): string {
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (value !== undefined && value !== "") query.set(key, String(value));
  }
  if (!query.has("basis")) query.set("basis", "gross");
  return query.toString();
}
